// src/components/SimpleMarkdown.js
//
// Minimal markdown-ish renderer for legal document text (headers, bold,
// bullet lists, horizontal rules, paragraphs). Not a general-purpose
// markdown parser -- just enough to make docs/TERMS_OF_SERVICE_DRAFT.md
// and docs/PRIVACY_POLICY_DRAFT.md readable without adding a markdown
// library dependency for two documents.

import React from 'react';

function renderInline(text, keyPrefix) {
    // Bold: **text**
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>;
        }
        return <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>;
    });
}

function SimpleMarkdown({ content }) {
    const lines = content.split('\n');
    const elements = [];
    let listBuffer = [];

    const flushList = (key) => {
        if (listBuffer.length > 0) {
            elements.push(
                <ul key={`list-${key}`} className="list-disc pl-6 mb-4 space-y-1">
                    {listBuffer.map((item, i) => (
                        <li key={i} className="text-gray-300 text-sm">{renderInline(item, `li-${key}-${i}`)}</li>
                    ))}
                </ul>
            );
            listBuffer = [];
        }
    };

    lines.forEach((line, idx) => {
        const trimmed = line.trim();

        if (trimmed === '' ) {
            flushList(idx);
            return;
        }
        if (trimmed === '---') {
            flushList(idx);
            elements.push(<hr key={idx} className="border-gray-700 my-6" />);
            return;
        }
        if (trimmed.startsWith('## ')) {
            flushList(idx);
            elements.push(<h2 key={idx} className="text-lg font-bold text-white mt-6 mb-2">{trimmed.slice(3)}</h2>);
            return;
        }
        if (trimmed.startsWith('# ')) {
            flushList(idx);
            elements.push(<h1 key={idx} className="text-xl font-black text-white mb-3">{trimmed.slice(2)}</h1>);
            return;
        }
        if (trimmed.startsWith('*') && trimmed.endsWith('*') && !trimmed.startsWith('**')) {
            flushList(idx);
            elements.push(<p key={idx} className="text-gray-500 text-xs italic mb-3">{trimmed.slice(1, -1)}</p>);
            return;
        }
        if (trimmed.startsWith('- ')) {
            listBuffer.push(trimmed.slice(2));
            return;
        }
        flushList(idx);
        elements.push(<p key={idx} className="text-gray-300 text-sm mb-3 leading-relaxed">{renderInline(trimmed, `p-${idx}`)}</p>);
    });
    flushList('end');

    return <div>{elements}</div>;
}

export default SimpleMarkdown;
